import { Media } from 'services/conversations/types';

export const getMediaFileName = (media: Media) => {
  return media.classifiedDocumentType || media.fileName;
};
